export const PRE_FOUNDATION_REGISTER = '/pfc/application/register'
export const PRE_FOUNDATION_PAYMENT = '/pfc/application/payment'
export const PRE_FOUNDATION_EXAM_RESULT = '/pfc/application/exam-result'
export const PRE_FOUNDATION_APPLICATIONS = '/pfc/application/applications'
export const PRE_FOUNDATION_EDIT = '/pfc/application/edit'
export const PRE_FOUNDATION_MY_APPLICATIONS = '/pfc/application/enrollment'
export const PRE_FOUNDATION_APPLICATION_CREATE = '/pfc/application/enrollment/create'
